import { useEffect, useState } from "react";
import { useStore } from "../lib/store";

/** Grace period so a short reconnect does not flash a banner. */
const SHOW_AFTER_MS = 1200;

export function ConnectionBanner() {
  const connection = useStore((s) => s.connection);
  const code = useStore((s) => s.code);
  const offline = code !== null && (connection === "connecting" || connection === "disconnected");
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (!offline) {
      setVisible(false);
      return;
    }
    const timer = setTimeout(() => setVisible(true), SHOW_AFTER_MS);
    return () => clearTimeout(timer);
  }, [offline]);

  if (!offline || !visible) return null;
  return (
    <div
      role="status"
      className="fixed inset-x-0 top-0 z-50 bg-warn px-4 pb-1.5 pt-[max(0.375rem,env(safe-area-inset-top))] text-center text-sm font-medium text-white dark:text-[#1a1300]"
    >
      {connection === "connecting" ? "Verbinde mit dem Server ..." : "Verbindung unterbrochen. Verbinde neu ..."}
    </div>
  );
}
